// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallSpeakerListBlock__container-bea2ce {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.CallSpeakerListBlock__blockName-caca0c {
  font: var(--font-subtitle-1);
  color: var(--base-80);
  margin: 16px 24px 0 24px;
  letter-spacing: var(--font-spacing-subtitle-1);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/popups/Permissions/CallPermissionsPopup/components/CallSpeakerListBlock/CallSpeakerListBlock.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,4BAAA;EACA,qBAAA;EACA,wBAAA;EACA,8CAAA;AACF","sourcesContent":[".container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.blockName {\n  font: var(--font-subtitle-1);\n  color: var(--base-80);\n  margin: 16px 24px 0 24px;\n  letter-spacing: var(--font-spacing-subtitle-1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CallSpeakerListBlock__container-bea2ce`,
	"blockName": `CallSpeakerListBlock__blockName-caca0c`
};
module.exports = ___CSS_LOADER_EXPORT___;
